import store from './redux'
import {getSubscriptionPlans} from "~/redux/user/subscription"
import getSymbolFromCurrency from 'currency-symbol-map'

export default {
  error: platform => store.dispatch({'type': 'error', 'args': platform}),
  createSubscription: (i, type) => store.dispatch({ type: 'createSubscription', args: { selected: i, type } }),
  login: priceType => store.dispatch({ 'type': 'login', 'args': priceType  }),
  updateProfile: fields => store.dispatch({ 'type': 'updateProfile', 'args': fields }),
  changePassword: fields => store.dispatch({ 'type': 'changePassword', 'args': fields }),
  manageDevices: devices  => store.dispatch({ 'type': 'manageDevices', 'args': devices }),
  forgotPassword: (hardwall, fields) => store.dispatch({ 'type': 'forgotPassword', args: {hardwall, fields} }),
  cancelSubscription: fields => store.dispatch({ 'type': 'cancelSubscription', 'args': fields }),
  upgradeSubscription: fields => store.dispatch({ 'type': 'upgradeSubscription', 'args': fields }),
  updateStripePayment: _ => store.dispatch({ 'type': 'updateStripePayment'}),
  billingHistory: fields => store.dispatch({ 'type': 'billingHistory', 'args': fields }),
  notice: _ => store.dispatch({ 'type': 'notice' }),
  episodeOverlay: episode =>store.dispatch({type: 'EpisodeOverlay', 'args': episode}),
  search: _ => store.dispatch({ 'type': 'search' }),
  hide: _ => store.dispatch({ 'type': 'hide' }),
  purchase: (plan, content, fn, purchase, type) => store.dispatch({ 'type': 'purchase', args: { plan, content, fn, purchase, type } }),
  equipment: _ => store.dispatch({'type': 'equipment'}),
  getSubscriptionPlans: _ => getSubscriptionPlans(),
  getSymbolFromCurrency: (sbl) => getSymbolFromCurrency(sbl),
  customOverlay: ({showCloseButton, renderContent}) => store.dispatch({'type': 'customOverlay', args: { showCloseButton, renderContent}}),
  searchList: _ => store.dispatch({ 'type': 'searchList' }),
  fitnessOnboardingScreen:({showCloseButton}) => store.dispatch({ type: 'fitnessOnboardingScreen', args: {showCloseButton}}),
  fitnessSignInCreate: ({showCloseButton, currentScreen}) => store.dispatch({ type: 'fitnessSignInCreate', args: {showCloseButton, currentScreen} }),
  fitnessChooseAPlan: ({showCloseButton}) => store.dispatch({ type: 'fitnessChooseAPlan', args: {showCloseButton} }),
  fitnessCheckout:({showCloseButton, selectedPlan, fields}) => store.dispatch({ type: 'fitnessCheckout', args: {showCloseButton, selectedPlan, fields}}),
  fitnessSetupProfile:({showCloseButton}) => store.dispatch({ type: 'fitnessSetupProfile', args: {showCloseButton}}),
  persolizationSetUpProfile:(recommendedButtonText) => store.dispatch({ type: 'persolizationSetUpProfile', args: {recommendedButtonText}}),
  providerList: _ => store.dispatch({ 'type': 'providerList' }),

}